import type { FC } from 'react'
import { useOutletContext } from 'react-router-dom'

import { LoyaltyProgram } from '@pages/IntroducingBroker/Dashboard/LoyaltyProgram/LoyaltyProgram'
import { useConsumeLoyaltyReward } from '@pages/IntroducingBroker/Dashboard/hooks/useConsumeLoyaltyReward'
import type { DashboardContextValue } from '@pages/IntroducingBroker/DashboardPoC/DashboardWrapper'
import { useIntroducingBrokerById } from '@pages/IntroducingBroker/hooks/useIntroducingBrokerById'

export const LoyaltyProgramWidget: FC = () => {
  const { data: introducingBroker, isLoading: isIntroducingBrokerLoading } =
    useIntroducingBrokerById()

  const { ibLoyaltyData, isLoyaltyDataLoading, refreshIbLoyaltyData } =
    useOutletContext<DashboardContextValue>()

  const { consumeLoyaltyReward, isLoading: isConsumeLoyaltyRewardLoading } =
    useConsumeLoyaltyReward({
      onComplete: refreshIbLoyaltyData,
    })

  const isLoading = isLoyaltyDataLoading || isIntroducingBrokerLoading

  return (
    <LoyaltyProgram
      isLoading={isLoading}
      loyaltyData={ibLoyaltyData ?? undefined}
      onClaimClick={consumeLoyaltyReward}
      ibData={introducingBroker}
      isConsumeLoyaltyRewardLoading={isConsumeLoyaltyRewardLoading}
    />
  )
}
